import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Dashboard.module.scss';
import Layout from '../../components/Layout';

interface DashboardTileProps {
  title: string;
  description: string;
  to: string;
}

const DashboardTile: React.FC<DashboardTileProps> = ({
  title,
  description,
  to,
}) => {
  return (
    <Link to={to} className={styles.tile}>
      <h2>{title}</h2>
      <p>{description}</p>
    </Link>
  );
};

export const Dashboard: React.FC = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.tilesContainer}>
          <DashboardTile
            title="Frequent Updates"
            description="Manage and view frequent updates jobs"
            to="/frequent-updates"
          />
          <DashboardTile
            title="Typesense Sync"
            description="Manage and view Typesense sync jobs"
            to="/typesense-sync"
          />
          {/* <DashboardTile
            title="Placeholder Tile"
            description="Future functionality will be here"
            to="/placeholder-1"
          />
          <DashboardTile
            title="Placeholder Tile"
            description="Future functionality will be here"
            to="/placeholder-2"
          />
          <DashboardTile
            title="Placeholder Tile"
            description="Future functionality will be here"
            to="/placeholder-3"
          /> */}
        </div>
      </div>
    </Layout>
  );
};
